import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import { Clock, Sparkles } from 'lucide-react';
export function UrgencyBanner() {
  const [spotsTaken, setSpotsTaken] = useState(() => {
    if (typeof window === 'undefined') return 66;
    const saved = sessionStorage.getItem('constelaciones-spots');
    if (saved) {
      const {
        value,
        timestamp
      } = JSON.parse(saved);
      const elapsed = (Date.now() - timestamp) / 1000;
      const increment = Math.floor(elapsed / 45) * 1;
      return Math.min(value + increment, 96);
    }
    return 66 + Math.floor(Math.random() * 6);
  });
  const [timeLeft, setTimeLeft] = useState({
    h: 23,
    m: 26,
    s: 46
  });
  useEffect(() => {
    if (typeof window === 'undefined') return;
    sessionStorage.setItem('constelaciones-spots', JSON.stringify({
      value: spotsTaken,
      timestamp: Date.now()
    }));
  }, [spotsTaken]);
  useEffect(() => {
    const interval = setInterval(() => {
      setSpotsTaken(prev => {
        if (prev >= 96) return prev;
        const increment = Math.random() < 0.3 ? 1 : 0;
        return Math.min(prev + increment, 96);
      });
    }, 30000 + Math.random() * 30000);
    return () => clearInterval(interval);
  }, []);
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => {
        let {
          h,
          m,
          s
        } = prev;
        if (s > 0) s--;else {
          s = 59;
          if (m > 0) m--;else {
            m = 59;
            if (h > 0) h--;
          }
        }
        return {
          h,
          m,
          s
        };
      });
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  const fmt = (n: number) => n.toString().padStart(2, '0');
  return <div className="sticky top-0 z-50 w-full bg-gradient-to-r from-brand-violetDark via-brand-violet to-brand-violetDark text-white shadow-md border-b border-brand-gold/30" data-id="element-410" data-mp="2cg5lfjv37l67">
      <div className="max-w-7xl mx-auto px-3 py-2 md:px-6 md:py-2.5" data-id="element-411" data-mp="10x2yfqwn6p14">
        {/* Mobile marquee */}
        <div className="md:hidden overflow-hidden relative" data-id="element-412" data-mp="12gl03wd3nk36">
          <motion.div className="flex items-center gap-6 whitespace-nowrap text-[11px] font-medium w-max" animate={{
          x: ['0%', '-50%']
        }} transition={{
          duration: 18,
          ease: 'linear',
          repeat: Infinity
        }} data-id="element-413" data-mp="17f63g4nnejvu">
            {[0, 1].map(dup => <div key={dup} className="flex items-center gap-6 shrink-0" data-id="element-414" data-mp="og1vz0br8y6a">
                <div className="flex items-center gap-1.5 shrink-0 text-brand-goldLight" data-id="element-415" data-mp="oi4u67n29xm3">
                  <Clock className="w-3.5 h-3.5 shrink-0" data-id="element-416" data-mp="9sywio3vgfgb" />
                  <span data-id="element-417" data-mp="epfndq2gh7x3">Precio de lanzamiento cierra en</span>
                  <span className="font-mono font-bold tabular-nums bg-white/15 rounded px-1.5 py-0.5 ml-0.5 text-white" data-id="element-418" data-mp="enw7i0kpoyvu">
                    {fmt(timeLeft.h)}:{fmt(timeLeft.m)}:{fmt(timeLeft.s)}
                  </span>
                </div>
                <span className="w-1 h-1 rounded-full bg-brand-goldLight/50 shrink-0" data-id="element-419" data-mp="3ia6bpobr5l58" />
                <div className="flex items-center gap-1.5 shrink-0" data-id="element-420" data-mp="3datqf80j4m4r">
                  <Sparkles className="w-3.5 h-3.5 shrink-0 animate-pulse text-brand-goldLight" data-id="element-421" data-mp="3r9teoek4qz0e" />
                  <span data-id="element-422" data-mp="3maq8gqseymqu">
                    <strong className="tabular-nums text-brand-goldLight" data-id="element-423" data-mp="3ma8fc311son5">
                      {spotsTaken}%
                    </strong>{' '}
                    de cupos tomados
                  </span>
                </div>
                <span className="w-1 h-1 rounded-full bg-brand-goldLight/50 shrink-0" data-id="element-424" data-mp="2qp1rjxx0sa" />
                <a href="#pricing" className="inline-flex items-center gap-1 bg-brand-goldLight text-brand-violetDark font-bold px-2.5 py-0.5 rounded-full text-[11px] shrink-0" data-id="element-425" data-mp="dtvha8kzaqsl">
                  Ver Vademécum →
                </a>
              </div>)}
          </motion.div>
        </div>

        {/* Desktop */}
        <div className="hidden md:flex items-center justify-center gap-3 md:gap-6 text-[11px] md:text-sm font-medium" data-id="element-426" data-mp="12wnr30ug52jv">
          <div className="flex items-center gap-1.5 md:gap-2 whitespace-nowrap text-brand-goldLight" data-id="element-427" data-mp="16wo6anpddhrz">
            <Clock className="w-3.5 h-3.5 md:w-4 md:h-4 shrink-0" data-id="element-428" data-mp="1bphclg0hky66" />
            <span className="hidden sm:inline" data-id="element-429" data-mp="1gn9caw7dhokx">
              Precio de lanzamiento cierra en
            </span>
            <span className="sm:hidden" data-id="element-430" data-mp="jy1p7jr3v7ew">Cierra en</span>
            <span className="font-mono font-bold tabular-nums bg-white/15 rounded px-1.5 py-0.5 ml-0.5 text-white" data-id="element-431" data-mp="jzcpvap97z1s">
              {fmt(timeLeft.h)}:{fmt(timeLeft.m)}:{fmt(timeLeft.s)}
            </span>
          </div>

          <div className="hidden md:block w-px h-4 bg-brand-goldLight/40 shrink-0" data-id="element-432" data-mp="xx1b4jn8h87d" />

          <div className="hidden md:flex items-center gap-2 whitespace-nowrap" data-id="element-433" data-mp="xuooht6j69nz">
            <Sparkles className="w-4 h-4 shrink-0 animate-pulse text-brand-goldLight" data-id="element-434" data-mp="24cvcnmzhe9ui" />
            <span data-id="element-435" data-mp="29an28acnljvj">
              <strong className="tabular-nums text-brand-goldLight" data-id="element-436" data-mp="29eavd8e6s49q">
                {spotsTaken}%
              </strong>{' '}
              de cupos tomados
            </span>
          </div>

          <a href="#pricing" className="hidden sm:inline-flex items-center gap-1 bg-brand-goldLight text-brand-violetDark font-bold px-3 py-1 rounded-full text-[11px] md:text-xs hover:bg-white transition-colors shrink-0" data-id="element-437" data-mp="3ox8t8kogkvay">
            Ver Vademécum →
          </a>
        </div>
      </div>
    </div>;
}